<template>
    <div>
        <!-- 手机端筛选弹窗 -->
        <el-drawer custom-class="my-drawer" title="筛选" :visible.sync="showMobileFilter" direction="btt" :before-close="handleClose" size="88%" :wrapperClosable="false">
            <div class="main-content">
                <!-- 所在省份 -->
                <div>
                    <div class="title">所在省份</div>
                    <div class="filter-select">
                        <el-select v-model="provinceId" placeholder="学校所在省份" filterable clearable style="width: 100%;">
                            <el-option v-for="item in provinceOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </div>
                </div>
                <!-- 产品分类 -->
                <MobileSelect v-model="productaActivedList" :options="[{id:'',name:'全部'}, ...productList]" label="产品分类" :props="{multi: true}" />
                <!-- 订购类型 -->
                <MobileSelect v-model="orderType" :options="orderTypeList" label="订购类型" />
                <!-- 销售人员 -->
                <template v-if="[3, 7].indexOf($store.state.userData.type) == -1">
                    <MobileSelect v-model="saleUserId" :options="salePersonOption" label="销售人员" />
                </template>
                <!-- 拜访日期 -->
                <div v-if="active === 'first'">
                    <div class="title">拜访日期</div>
                    <div class="filter-date-box">
                        <el-date-picker style="width: 100%" v-model="visitDayStart" type="date" placeholder="开始时间" value-format="yyyy-MM-dd" />
                        <span>-</span>
                        <el-date-picker style="width: 100%" v-model="visitDayEnd" type="date" placeholder="结束时间" value-format="yyyy-MM-dd" />
                    </div>
                </div>
                <!-- 到期状态 -->
                <MobileSelect v-model="statusList" :options="expiredOptions" label="到期状态" :props="{multi: true}" />
            </div>
            <div class="footer-btn">
                <div class="button cancel" @click="handleClose">取消</div>
                <div class="button confirm" @click="confirm">确定</div>
            </div>
        </el-drawer>
    </div>
</template>
<script>
import { mapState } from "vuex";

export default {
    props: {
        showMobileFilter: {
            type: Boolean,
            default: false,
        },
        form: {
            type: Object,
            default: () => { },
        },
        active: String,
    },
    data() {
        return {
            productaActivedList: [],
            orderType: "",
            saleUserId: "",
            visitDayStart: "",
            visitDayEnd: "",
            statusList: [],
            provinceId: "",
            expiredOptions: [{ id: '', name: '全部' }, { id: 0, name: '正常' }, { id: 1, name: '即将到期' }, { id: 2, name: '已到期' }],
        };
    },
    watch: {
        showMobileFilter(val) {
            if (!val) {
                return;
            }
            this.$nextTick(() => {
                let param = JSON.parse(JSON.stringify(this.form));
                this.productaActivedList = param.productIdList;
                this.orderType = param.orderType;
                this.saleUserId = param.saleUserId;
                this.statusList = param.statusList;
                this.provinceId = param.provinceId;
            });
        },
    },
    computed: {
        ...mapState(["orderTypeList", "productList", "salePersonOption", "userData", "provinceOptions"]),
    },
    methods: {
        getDefaultSale() {
            let flag = this.salePersonOption.filter((i) => i.id == this.userData.userId).length;
            this.saleUserId = flag > 0 ? this.userData.userId : "";
        },
        confirm() {
            this.$emit("confirm", this.productaActivedList, this.orderType, this.saleUserId, this.visitDayStart, this.visitDayEnd, this.statusList, this.provinceId);
            this.handleClose();
        },
        handleClose() {
            this.productaActivedList = [];
            this.orderType = "";
            this.getDefaultSale();
            this.$emit("update:showMobileFilter", false);
        },
    },
};
</script>
<style lang="scss" scoped>
.main-content {
    padding: 0 1.5rem 7rem;
    .title {
        font-size: 1.14rem;
        font-weight: 550;
        margin: 1rem 0;
    }
    .item-select {
        width: calc((100% / 2) - 0.5rem);
        text-align: center;
        display: inline-block;
        padding: 0.5rem 0.8rem;
        border-radius: 8px;
        color: #333333;
        background-color: rgba(0, 0, 0, 0.05);
        margin: 0 0.5rem 0.5rem 0;
    }
    .item-select-active {
        border: 1px solid $primary-btn-color;
        color: $primary-btn-color;
        background-color: rgba(4, 65, 144, 0.1);
    }
}
.footer-btn {
    padding: 10px 20px;
    background-color: #fff;
    position: absolute;
    bottom: 0;
    width: 100%;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
    @include SAFE-BOTTOM-IOS;
    display: flex;
    .button {
        border-radius: 12px;
        border: none;
        padding: 0.86rem 0;
        font-size: 1.14rem;
        text-align: center;
    }
    .cancel {
        width: 25%;
        color: $primary-font-color;
        margin-right: 1rem;
        background-color: rgba(0, 0, 0, 0.08);
    }
    .confirm {
        flex: 1;
        background-color: $primary-btn-color;
        color: #fff;
    }
}
</style>
<style lang="scss">
.my-drawer {
    border-radius: 12px 12px 0 0;
    .el-drawer__header {
        text-align: center;
        color: $primary-font-color;
        font-weight: 550;
        font-size: 1.14rem;
        margin-bottom: 1rem;
        padding-left: 40px;
    }
}
.filter-date-box {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}
</style>
